module.exports = __webpack_public_path__ + "media/src/images/icons/calendar-header-e12a749f5555cf55ee669911920fb990.svg";